var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('selectable-brands',{attrs:{"grid-options":_vm.options,"show-chips":"","items":_vm.value.brand ? [_vm.value.brand] : undefined},model:{value:(_vm.product),callback:function ($$v) {_vm.product=$$v},expression:"product"}})}
var staticRenderFns = []

export { render, staticRenderFns }